module.exports = __webpack_public_path__ + "static/media/administrator-avatar.1646c1d4.png";